import { Application } from '@hotwired/stimulus'
import AccountLevelInfoController from '~/controllers/account_level_info_controller'
import AcknowledgeActionController from '~/controllers/acknowledge_action_controller'
import AdminGuardianGlobalDashboardFiltersController from '~/controllers/admin/guardian_global_dashboard/filters_controller'
import AdminGuardianGlobalDashboardRowController from '~/controllers/admin/guardian_global_dashboard/row_controller'
import AdminGuardianGlobalDashboardSignalController from '~/controllers/admin/guardian_global_dashboard/signal_controller'
import GuardianBackupHistoryController from '~/controllers/aws/guardian_dashboard/backup_history_controller'
import CrowdstrikeDetectionTrendChartController from '~/controllers/aws/guardian_dashboard/crowdstrike_detection_trend_chart_controller'
import GuardianContextTabsController from '~/controllers/aws/guardian_dashboard/guardian_context_tabs_controller'
import GuardianFiltersController from '~/controllers/aws/guardian_dashboard/guardian_filters_controller'
import PatchManagementTrendChartController from '~/controllers/aws/guardian_dashboard/patch_management_trend_chart_controller'
import ServiceDeskMttResolveTrendChartController from '~/controllers/aws/guardian_dashboard/service_desk_mtt_resolve_trend_chart_controller'
import ServiceDeskMttRespTrendChartController from '~/controllers/aws/guardian_dashboard/service_desk_mtt_resp_trend_chart_controller'
import ServiceDeskSupportWindowController from '~/controllers/aws/guardian_dashboard/service_desk_support_window_controller'
import ServiceDeskVolumeTrendChartController from '~/controllers/aws/guardian_dashboard/service_desk_volume_trend_chart_controller'
import AWSCredentialsFormController from '~/controllers/aws_credentials_form_controller'
// resource metrics
import AWSEBSMetricsChartsController from '~/controllers/aws_ebs_metrics_charts_controller'
import AWSEC2CpuCapacityMonthlyUtilizationChartController from '~/controllers/aws_ec2_cpu_capacity_monthly_utilization_chart_controller'
import AWSEC2MetricsChartsController from '~/controllers/aws_ec2_metrics_charts_controller'
import AWSEc2OptimizationController from '~/controllers/aws_ec2_optimization_controller'
import AWSEKSClusterCapacityChartsController from '~/controllers/aws_eks_cluster_capacity_charts_controller'
import AWSEKSDashboardChartsController from '~/controllers/aws_eks_dashboard_charts_controller'
import AwsEKSNodegroupDrilldownController from '~/controllers/aws_eks_nodegroup_drilldown_controller'
import AWSElasticacheOptimizationController from '~/controllers/aws_elasticache_optimization_controller'
import AWSMasterOptimizationsChartOnlyController from '~/controllers/aws_master_optimizations_chart_only_controller'
import AwsOpensearchCpuRightSizeRecommendationsController from '~/controllers/aws_opensearch_cpu_right_size_recommendations_controller'
import AWSOpensearchOptimizationController from '~/controllers/aws_opensearch_optimization_controller'
import AwsRdsCpuRightSizeRecommendationsController from '~/controllers/aws_rds_cpu_right_size_recommendations_controller'
import AwsRdsMemoryRightSizeRecommendationsController from '~/controllers/aws_rds_memory_right_size_recommendations_controller'
import AWSRDSMetricsChartsController from '~/controllers/aws_rds_metrics_charts_controller'
import AWSRdsOptimizationController from '~/controllers/aws_rds_optimization_controller'
import AWSS3DashboardChartsController from '~/controllers/aws_s3_dashboard_charts_controller'
import AWSStorageOptimizationController from '~/controllers/aws_storage_optimization_controller'
// dashboards
import AzureDatabaseDashboardChartsController from '~/controllers/azure_database_dashboard_charts_controller'
import AzureDatabaseOptimizationController from '~/controllers/azure_database_optimization_controller'
import AzureDiskOptimizationController from '~/controllers/azure_disk_optimization_controller'
import AzureMasterOptimizationsChartOnlyController from '~/controllers/azure_master_optimizations_chart_only_controller'
import AzureStorageDashboardChartsController from '~/controllers/azure_storage_dashboard_charts_controller'
import AzureVmOptimizationController from '~/controllers/azure_vm_optimization_controller'
import BillingV2AccountTagFiltersController from '~/controllers/billing_v2_account_tag_filters_controller'
import ChatController from '~/controllers/chat_controller'
import ChatMessagesController from '~/controllers/chat_messages_controller'
import ClipboardController from '~/controllers/clipboard_controller'
import CronGeneratorController from '~/controllers/cron_generator_controller'
import CurrencyInputController from '~/controllers/currency_input_controller'
import DynamicSearchController from '~/controllers/dynamic_search_controller'
import DynamicTableController from '~/controllers/dynamic_table_controller'
import EChartsController from '~/controllers/echarts'
import EksContainerRecommendationController from '~/controllers/eks_container_recommendation_controller'
import EksSplitCostController from '~/controllers/eks_split_cost_controller'
import ExpandableTableController from '~/controllers/expandable_table_controller'
import FeatureFormController from '~/controllers/feature_form_controller'
import MarketplaceBillingController from '~/controllers/marketplace_billing_controller'
import MenuSearchController from '~/controllers/menu_search_controller'
import MenuSectionsController from '~/controllers/menu_sections_controller'
import ModalController from '~/controllers/modal_controller'
import NotificationDropdownController from '~/controllers/notification_dropdown_controller'
import NotificationToastController from '~/controllers/notification_toast_controller'
import OptimizationFormController from '~/controllers/optimization_form_controller'
import OrganizationSwitcherController from '~/controllers/organization_switcher_controller'
import PlanNavigationController from '~/controllers/plan_navigation_controller'
import PopoverController from '~/controllers/popover_controller'
import SearchController from '~/controllers/search_controller'
import SidebarDropdownController from '~/controllers/sidebar_dropdown_controller'
import SidebarNotificationsController from '~/controllers/sidebar_notifications_controller'
import SidebarScrollController from '~/controllers/sidebar_scroll_controller'
import TomSelectController from '~/controllers/tom_select_controller'
import TooltipController from '~/controllers/tooltip_controller'

export function init() {
  const application = Application.start()

  application.register('clipboard', ClipboardController)
  application.register('currency-input', CurrencyInputController)
  application.register('dynamic-search', DynamicSearchController)
  application.register('dynamic-table', DynamicTableController)
  application.register('echarts', EChartsController)
  application.register('tom-select', TomSelectController)
  application.register('modal', ModalController)
  application.register('organization-switcher', OrganizationSwitcherController)
  application.register('menu-search', MenuSearchController)
  application.register('sidebar-notifications', SidebarNotificationsController)
  application.register('menu-sections', MenuSectionsController)
  application.register('search', SearchController)
  application.register('sidebar-dropdown', SidebarDropdownController)
  application.register('sidebar-scroll', SidebarScrollController)
  application.register('popover', PopoverController)
  application.register('aws-credentials-form', AWSCredentialsFormController)
  application.register('chat', ChatController)
  application.register('chat-messages', ChatMessagesController)
  application.register('expandable-table', ExpandableTableController)
  application.register('cron-generator', CronGeneratorController)
  application.register('tooltip', TooltipController)
  application.register('acknowledge-action', AcknowledgeActionController)
  application.register('admin-guardian-global-dashboard-filters', AdminGuardianGlobalDashboardFiltersController)
  application.register('admin-guardian-global-dashboard-row', AdminGuardianGlobalDashboardRowController)
  application.register('admin-guardian-global-dashboard-signal', AdminGuardianGlobalDashboardSignalController)
  application.register('notification-toast', NotificationToastController)
  application.register('notification-dropdown', NotificationDropdownController)
  application.register('account-level-info', AccountLevelInfoController)
  application.register('billing-v2-account-tag-filters', BillingV2AccountTagFiltersController)
  application.register('plan-navigation', PlanNavigationController)
  application.register('eks-split-cost', EksSplitCostController)

  // dashboards
  application.register('aws-s3-dashboard-charts', AWSS3DashboardChartsController)
  application.register('aws-eks-dashboard-charts', AWSEKSDashboardChartsController)
  application.register('aws-eks-cluster-capacity-charts', AWSEKSClusterCapacityChartsController)
  application.register(
    'aws-ec2-cpu-capacity-monthly-utilization-chart',
    AWSEC2CpuCapacityMonthlyUtilizationChartController,
  )
  application.register('azure-database-dashboard-charts', AzureDatabaseDashboardChartsController)
  application.register('azure-storage-dashboard-charts', AzureStorageDashboardChartsController)
  application.register('guardian-filters', GuardianFiltersController)
  application.register('guardian-context-tabs', GuardianContextTabsController)
  application.register('guardian-backup-history', GuardianBackupHistoryController)
  application.register('crowdstrike-detection-trend-chart', CrowdstrikeDetectionTrendChartController)
  application.register('patch-management-trend-chart', PatchManagementTrendChartController)
  application.register('service-desk-support-window', ServiceDeskSupportWindowController)
  application.register('service-desk-volume-trend-chart', ServiceDeskVolumeTrendChartController)
  application.register('service-desk-mtt-resp-trend-chart', ServiceDeskMttRespTrendChartController)
  application.register('service-desk-mtt-resolve-trend-chart', ServiceDeskMttResolveTrendChartController)

  // resource metrics
  application.register('aws-ebs-metrics-charts', AWSEBSMetricsChartsController)
  application.register('aws-ec2-metrics-charts', AWSEC2MetricsChartsController)
  application.register('aws-rds-metrics-charts', AWSRDSMetricsChartsController)
  application.register('aws-eks-nodegroup-drilldown', AwsEKSNodegroupDrilldownController)
  application.register('aws-rds-cpu-right-size-recommendations', AwsRdsCpuRightSizeRecommendationsController)
  application.register('aws-rds-memory-right-size-recommendations', AwsRdsMemoryRightSizeRecommendationsController)
  application.register(
    'aws-opensearch-cpu-right-size-recommendations',
    AwsOpensearchCpuRightSizeRecommendationsController,
  )
  application.register('eks-container-recommendation', EksContainerRecommendationController)
  application.register('optimization-form', OptimizationFormController)
  application.register('feature-form', FeatureFormController)
  application.register('azure-master-optimizations-chart-only', AzureMasterOptimizationsChartOnlyController)
  application.register('azure-vm-optimization', AzureVmOptimizationController)
  application.register('azure-database-optimization', AzureDatabaseOptimizationController)
  application.register('azure-disk-optimization', AzureDiskOptimizationController)
  application.register('aws-master-optimizations-chart-only', AWSMasterOptimizationsChartOnlyController)
  application.register('aws-ec2-optimization', AWSEc2OptimizationController)
  application.register('aws-rds-optimization', AWSRdsOptimizationController)
  application.register('aws-storage-optimization', AWSStorageOptimizationController)
  application.register('aws-elasticache-optimization', AWSElasticacheOptimizationController)
  application.register('aws-opensearch-optimization', AWSOpensearchOptimizationController)
  application.register('marketplace-billing', MarketplaceBillingController)
}
